var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function calcTotal(coin, balances, price) {
    var _a, _b;
    var title = (_a = coin.title) !== null && _a !== void 0 ? _a : "";
    var onWallet = title && title in balances ? balances[title] : 0;
    var owned = (_b = coin.owned) !== null && _b !== void 0 ? _b : 0;
    return (owned + onWallet) * price;
}
export function sortCoins(coins, sortBy) {
    return __spreadArray([], coins, true).sort(function (a, b) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (sortBy) {
            case "az":
                return ((_a = a.title) !== null && _a !== void 0 ? _a : "").localeCompare((_b = b.title) !== null && _b !== void 0 ? _b : "");
            case "za":
                return ((_c = b.title) !== null && _c !== void 0 ? _c : "").localeCompare((_d = a.title) !== null && _d !== void 0 ? _d : "");
            case "low":
                return ((_e = a.price) !== null && _e !== void 0 ? _e : 0) - ((_f = b.price) !== null && _f !== void 0 ? _f : 0);
            case "high":
                return ((_g = b.price) !== null && _g !== void 0 ? _g : 0) - ((_h = a.price) !== null && _h !== void 0 ? _h : 0);
            default:
                return 0;
        }
    });
}
